<div class="dialog-off-canvas-main-canvas" data-off-canvas-main-canvas="" *ngIf="translateService.currentLang==='en'">
    <div class="fluid-container header-wrapper">
        <div class="row">
            <div class="col-sm-12">
                <div class="region region-header">
                    <section id="block-herobanner" class="block block-cdlsimod block-hero-content clearfix">
                        <div class="hero-wrapper">
                            <img src="./assets/images/pics/home-banner-2021-en.jpg" alt="Canadian Dealer Lease Services Inc." class="hero-image" width="100%" height="auto">
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>

    <div id="main-content" class="highlighted-container container">
        <div class="row">
            <div class="highlighted">  
                <div class="region region-highlighted">
                    <h1 class="page-header">
                        <span>Customer Focused, Service Driven</span>
                    </h1>
                </div>
            </div>
        </div>
    </div>

    <div role="main" class="main-container container js-quickedit-main-content" style="margin-top: 30px; margin-bottom: 30px;">
        <div class="row">
            <section class="col-sm-12">
                <div class="region region-content">
                    <article data-history-node-id="1" class="page full clearfix">
                        <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                <p><strong>Canadian Dealer Lease Services Inc. (CDLSI)</strong> is an industry leader in lease services for Canada’s retail automotive leasing industry. Since CDLSI was founded in 2011, our company has expanded rapidly because of our industry partnerships, and the robust, scalable leasing programs that meet the individual needs of our clients.</p>
                                <p>We operate in both official languages, and continue to grow our team, expand our offices, and develop new services and technologies. CDLSI is committed to great teams, a great culture, great training, and great leadership. Most importantly, we are committed to providing a great customer experience.</p>
                            </div>   
                        </div>
                    </article>
                </div>
            </section>
        </div>
    </div>
</div>

<div class="dialog-off-canvas-main-canvas" data-off-canvas-main-canvas="" *ngIf="translateService.currentLang==='fr'">
    <div class="fluid-container header-wrapper">
        <div class="row">
            <div class="col-sm-12">
                <div class="region region-header">
                    <section id="block-herobanner" class="block block-cdlsimod block-hero-content clearfix">
                        <div class="hero-wrapper">
                            <img src="./assets/images/pics/home-banner-2021-fr.jpg" alt="Services de location des concessionnaires automobiles canadiens." class="hero-image" width="100%" height="auto">
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>

    <div id="main-content" class="highlighted-container container">
        <div class="row">
            <div class="highlighted">  
                <div class="region region-highlighted">
                    <h1 class="page-header">
                        <span>Une entreprise ciblée sur le client et sur le service</span>
                    </h1>
                </div>
            </div>
        </div>
    </div>

    <div role="main" class="main-container container js-quickedit-main-content" style="margin-top: 30px; margin-bottom: 30px;">
        <div class="row">
            <section class="col-sm-12">
                <div class="region region-content">
                    <article data-history-node-id="1" class="page full clearfix">
                        <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                <p><strong>Services de location des concessionnaires automobiles canadiens&nbsp;(CDLSI)</strong> est un chef de file du secteur des services de location pour le secteur de la location automobile au détail au Canada. Depuis la fondation de CDLSI en 2011, notre entreprise a connu une expansion rapide en raison de nos partenariats dans le secteur et de programmes de location solides et évolutifs qui répondent aux besoins individuels de nos clients.</p>
                                <p>Nous exerçons dans les deux langues officielles et continuons d’élargir notre équipe, d’agrandir nos bureaux et de développer de nouveaux services et de nouvelles technologies. CDLSI s’engage à avoir d’excellentes équipes, une excellente culture, une excellente formation et une excellente direction. Mais surtout, nous nous engageons à offrir une excellente expérience client.</p>
                            </div>   
                        </div>
                    </article>
                </div>
            </section>
        </div>
    </div>
</div>
